<ng-container
    *appHasPermissionId="
        type === 'kpi-result'
            ? permissionList.kpiResultEntry
            : permissionList.kpiResultFlow
    "
>
    @if (mode === 'default' && !isPeriodApproved(period)) {
        <div class="mb-3 flex justify-end">
            <button
                (click)="showCreateAttachmentDialog()"
                class="btn btn-sm btn-white"
            >
                <i class="fa-light fa-plus"></i>
                <span> {{ 'translate_new_attachment' | translate }}</span>
            </button>
        </div>
    }
</ng-container>

<!-- Table -->
<app-list-loading [items]="items">
    <div class="overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div class="table-responsive">
            <table>
                <thead class="thead-dark">
                    <tr>
                        <th>{{ 'translate_type' | translate }}</th>
                        <th>{{ 'translate_name' | translate }}</th>
                        @if (!period) {
                            <th>
                                {{ 'translate_period' | translate }}
                            </th>
                        }
                        <ng-container
                            *appHasPermissionId="
                                type === 'kpi-result'
                                    ? permissionList.kpiResultEntry
                                    : permissionList.kpiResultFlow
                            "
                        >
                            @if (
                                mode === 'default' && !isPeriodApproved(period)
                            ) {
                                <th></th>
                            }
                        </ng-container>
                    </tr>
                </thead>

                <tbody>
                    @for (item of items; track item; let idx = $index) {
                        <tr>
                            <!-- Icon -->
                            <td>
                                <app-file-icon
                                    [contentType]="item.contentType"
                                ></app-file-icon>
                            </td>
                            <!-- File name -->
                            <td>
                                <a
                                    href="#"
                                    onclick="return false;"
                                    (click)="
                                        download(
                                            item.id,
                                            item.contentType,
                                            item.name
                                        )
                                    "
                                >
                                    {{ item.name }}
                                </a>
                            </td>
                            <!-- Period -->
                            @if (!period) {
                                <td class="text-center">
                                    <app-kpi-result-attachment-period-label
                                        [period]="item.period"
                                        [periodType]="item.periodType"
                                    ></app-kpi-result-attachment-period-label>
                                </td>
                            }
                            <!-- Control -->
                            @if (
                                mode === 'default' && !isPeriodApproved(period)
                            ) {
                                <td style="width: 1%; white-space: nowrap">
                                    <app-delete-button
                                        *appHasPermissionId="
                                            type === 'kpi-result'
                                                ? permissionList.kpiResultEntry
                                                : permissionList.kpiResultFlow
                                        "
                                        [isDisabled]="
                                            currentlyDeleting.includes(item.id)
                                        "
                                        (delete)="delete(item)"
                                        [itemName]="item.name"
                                        [appTooltip]="
                                            'translate_delete' | translate
                                        "
                                    ></app-delete-button>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</app-list-loading>
